import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import queryTypeModal from "@/components/common/queryTypeModal.vue";
import IframeView from "@/components/public/IframeView.vue";
import { bpmnStartProcess } from "@/api/bpmnApi/bpmn";
export default {
  name: "SUBJECT",
  components: {
    queryTypeModal: queryTypeModal,
    IframeView: IframeView
  },
  props: ["moduleData"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      dataModal: {
        show: false,
        data: {}
      },
      middlePage: JSON.parse(window.sessionStorage.getItem("setConfig")).middlePage
    };
  },
  computed: {},
  created: function created() {
    this.moduleData.cardModules.forEach(function (item) {
      if (item.data.length) {
        item.activeTab = item.data[0];
      }
    });
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    tabClick: function tabClick(item, index) {
      this.moduleData.cardModules[index].activeTab = item;
      this.$forceUpdate();
    },
    goServe: function goServe(row) {
      if (row.serveType == "0" && row.queryType == "2") {
        this.dataModal.show = true;
        this.dataModal.data = row;
      }

      if (row.serveType == "0" && row.queryType == "1") {
        this.$refs.IframeView.showView(row.queryPcUrl, row.taskInstId);
      }

      if (row.serveType == "1") {
        if (!this.middlePage) {
          this.HandleApply(row);
        } else {
          var routeData = this.$router.resolve({
            path: "/ServeCenterDetail",
            query: {
              id: row.serveId
            }
          });
          window.open(routeData.href);
        }
      }
    },
    onDialogClose: function onDialogClose() {
      this.dataModal.show = false;
    },
    HandleApply: function HandleApply(item) {
      var _this = this;

      var processDefId = item.processDefId;
      bpmnStartProcess({
        processDefId: processDefId
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          window.sessionStorage.setItem("processInstId", data.data.processInstId);

          _this.$refs.IframeView.showView(data.data.url, data.data.taskInstId); // window.open(data.data.url);

        } else {
          _this.$message.warning(data.msg || "流程系统业务忙，请刷新或者重新操作");
        }
      }).catch(function (err) {
        _this.$message.error("服务异常");
      });
    },
    moreServe: function moreServe() {},
    goSubject: function goSubject() {
      var routeData = this.$router.resolve({
        path: "/serveCenter"
      });
      window.open(routeData.href);
    }
  },
  watch: {},
  filters: {}
};